<!-- 菜单页代码  contextButton/index.vue -->
<template>
  <div
    id="contextmenu"
    class="contextmenu"
  >
    <div
      class="contextmenu__item"
      @click="salesOrder()"
    >销单</div>
    <div
      class="contextmenu__item"
      @click="toAppend()"
      style="color: red;"
    >追加订单</div>
    <div
      class="contextmenu__item"
      v-if="orderPay_show"
      @click="orderPayment()"
    >订单支付</div>
    <div
            class="contextmenu__item"
            @click="paymentEmptyFare()"
    >结算空驶费</div>
    <div
      class="contextmenu__item"
      v-if="transferMenu"
      @click="transferOrder()"
      style="color: rgb(1, 173, 159);"
    >协助指派</div>
    <div
      class="contextmenu__item"
      v-if="orderBackMenu"
      @click="orderBack()"
    >订单收回</div>
    <div
      class="contextmenu__item"
      @click="visitOrder()"
    >订单回访</div>
    <div
      class="contextmenu__item"
      @click="editOrder()"
    >订单修改</div>
    <div
      class="contextmenu__item"
      @click="orderAssess()"
    >订单评价</div>
    <div
      class="contextmenu__item"
      @click="toCoupon()"
    >查看订单所用优惠券</div>
  </div>
</template>

<script>
export default {
    name: 'index',
    props: {
        data: '',
        orderPay: Boolean,
        orderPayment_money: '',
        transferOrder_city: '',
        orderBackMenu_show: Boolean,
        transferOrder_start: '',
        transferOrderMenu_show: Boolean,
        visitOrder_status: '',
        visitOrder_phone: '',
      paymentEmptyFare_money:''
    },

    data() {
        return {
            orderPay_show: this.orderPay,
            city_name: this.transferOrder_city,
            orderBackMenu: this.orderBackMenu_show,
            start: this.transferOrder_start,
            transferMenu: this.transferOrderMenu_show
        };
    },
    methods: {
        init(row, column, event) {
            // 设置菜单出现的位置
            // 具体显示位置根据自己需求进行调节
            let menu = document.querySelector('#contextmenu');

            menu.style.top = event.pageY + 'px';
            menu.style.left = event.pageX + 'px';

            document.addEventListener('click', this.foo); // 给整个document添加监听鼠标事件，点击任何位置执行foo方法
        },
        foo() {
            this.$emit('foo');
        },
        // 销单方法
        salesOrder() {
            this.$emit('salesOrder', this.data);
        },
        //支付空驶费
      paymentEmptyFare(){
        this.$emit('paymentEmptyFare', this.data, this.paymentEmptyFare_money);
      },
        //订单支付方法
        orderPayment() {
            this.$emit('orderPayment', this.data, this.orderPayment_money);
        },
        transferOrder() {
            this.$emit('transferOrder', this.data, this.city_name, this.start);
        },
        orderBack() {
            this.$emit('orderBack', this.data);
        },
        toAppend() {
            this.$emit('toAppend', this.data, this.city_name, this.start);
        },
        visitOrder() {
            this.$emit('visitOrder', this.data, this.visitOrder_status,  this.visitOrder_phone);
        },
        editOrder() {
            this.$emit('editOrder', this.data);
        },
        orderAssess(){
           this.$emit('orderAssess', this.data);
        },
        toCoupon(){
          this.$emit('toCoupon', this.data);
        }
    }
};
</script>

<style scoped>
.contextmenu__item {
    display: block;
    line-height: 34px;
    text-align: center;
}

.contextmenu__item:not(:last-child) {
    border-bottom: 1px solid rgba(64, 158, 255, 0.2);
}

.contextmenu {
    position: fixed;
    background-color: #ecf5ff;
    width: 130px;
    font-size: 12px;
    font-weight: 500;
    color: #409eff;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid rgba(64, 158, 255, 0.2);
    white-space: nowrap;
    z-index: 1000;
}

.contextmenu__item:hover {
    cursor: pointer;
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
}
</style>
